export const config = {
  AboutIntro: {
    title: 'About you',
    description: 'Tell us a little bit about yourself so your Beauty Guide can prepare for your appointment.',
  },
  AboutYouForm: {
    yourDetailsTitle: 'Your details',
  },
};
